import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebase.config";
import { SUBSCRIPTIONS_COL } from "../helper/constants";

export const getSubscriptionById = async (subscriptionId) => {
  if (!subscriptionId) return null;

  const snap = await getDoc(doc(db, SUBSCRIPTIONS_COL, subscriptionId));

  if (!snap.exists()) return null;

  const data = snap.data();

  return {
    subscriptionId: snap.id,
    isPaid: data.isPaid || false,
    expired: data.expired || false,
    cancelAtPeriodEnd: data.cancelAtPeriodEnd || false,
    planCredits: data.stripeCredits || 0,
    enterpriseCredits: data.corporateCredits || 0,
    creditsForNextCycle: data.creditsForNextCycle || 0,
    planRenewalDate: data.periodEnd ? new Date(data.periodEnd) : null,
    planStartDate: data.periodStart ? new Date(data.periodStart) : null,
    stripeSubscriptionId: data.stripeSubscriptionId || null,
    stripeCustomerId: data.stripeCustomerId || null,
    creationDate: data.creationDate?.toDate() || null,
    lastUpdateDate: data.lastUpdateDate?.toDate() || null,
  };
};
